import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import {
  GetTemplatesRequest,
  TemplateApiResponse,
  TemplateOptions
} from "./interfaces/get-templates";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getTemplates(
  data: GetTemplatesRequest,
  env: Environment
): Promise<TemplateOptions> {
  const url = `${getBaseUrl(env)}cxm/templates`;
  const header = await getHeader();
  const queryParams = new URLSearchParams({
    dealerId: data.dealerId.toString(),
    conversationType: data.conversationType
  });

  const response = await fetchWrapper.getAsync<TemplateApiResponse>(
    `${url}?${queryParams.toString()}`,
    header
  );

  if (response && response.data && !response.hasError) {
    return response.data.templateCategories || {};
  } else {
    console.warn(
      `Error fetching templates for dealerId: ${data.dealerId}, conversationType: ${data.conversationType}`,
      response?.error
    );
    return {}; // Return empty response on error
  }
}
